import React from "react";

import { Route, RouteProps } from "react-router-dom";

// Source
import * as HelperSrc from "../../HelperSrc";
import ControllerRoute from "../../controller/Route";
import ViewPageAccessDenied from "../PageAccessDenied";
import ViewPageDocumentList from "./PageDocumentList";
import ViewPageDocumentCreate from "./PageDocumentCreate";
import ViewPageDocumentPreview from "./PageDocumentPreview";
import ViewPageDocumentConfirm from "./PageDocumentConfirm";

const viewRoute: React.FC = () => {
    // Variable
    const controllerRoute = new ControllerRoute();

    const [getIsRendered, setIsRendered] = React.useState(false);

    // Method
    controllerRoute.initializeHook();

    React.useEffect(() => {
        const init = async () => {
            await controllerRoute.checkRedirect();

            setIsRendered(true);
        };

        init();
    }, []);

    // Render
    if (getIsRendered && controllerRoute.getStorageMain && !controllerRoute.getApiLoadingList.myProfile) {
        if (controllerRoute.getStorageMain) {
            if (controllerRoute.getUserData) {
                HelperSrc.checkSessionTimeout(controllerRoute.getStorageMain, controllerRoute.getStorageSetting, controllerRoute.getUserData);

                return (
                    <>
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.documentList.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.documentList.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageDocumentList {...props} userData={controllerRoute.getUserData} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.documentCreate.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.documentCreate.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageDocumentCreate {...props} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.documentPreview.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.documentPreview.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageDocumentPreview {...props} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                        <Route
                            exact
                            path={controllerRoute.getStorageMain.documentConfirm.path}
                            render={(props: RouteProps) => {
                                if (controllerRoute.getStorageMain) {
                                    const role = controllerRoute.getStorageMain.documentConfirm.role;

                                    if (controllerRoute.checkUserAccess(role)) {
                                        return <ViewPageDocumentConfirm {...props} />;
                                    } else {
                                        return <ViewPageAccessDenied role={role} />;
                                    }
                                }
                            }}
                        />
                    </>
                );
            } else {
                return <></>;
            }
        } else {
            return <></>;
        }
    } else {
        return <></>;
    }
};

export default viewRoute;
